import './index.css';

const NotFound = () => {
  return (
    <div className="container page-not-found">
      <h2>Page not found</h2>
    </div>
  );
};

export default NotFound;
